import { render, staticRenderFns } from "./bulkCertificateSubmission.vue?vue&type=template&id=4c074d42"
import script from "./bulkCertificateSubmission.vue?vue&type=script&lang=js"
export * from "./bulkCertificateSubmission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports